import { InteractionRequiredAuthError } from "@azure/msal-browser";

export const getAccountRoles = (account) => {
  if (!account || !account.idTokenClaims) return [];
  return account.idTokenClaims.roles || [];
};

export const userHasRequiredRole = (account, requiredRole) => {
  const roles = getAccountRoles(account);
  const requiredRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];

  return requiredRoles.some((role) => roles.includes(role));
};

export const acquireToken = async (msalInstance, account) => {
  const request = {
    scopes: ["4f76332f-798f-45bb-a7b8-83d869286233/.default"],
    account: account,
  };

  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(request);
      return new Promise(() => {});
    }

    throw error;
  }
};
